<div>
    <mat-card>
      <mat-card-header class="titreFrm">
        <mat-card-title>{{nomEcran.toUpperCase()}}</mat-card-title>
      </mat-card-header>
      <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
          <mat-card class="example-card carClass">
            <mat-card-content>
              <form class="example-form" #form="ngForm">
                <div class="btn">
                  <button (click)="ajouter(form)" [disabled]="disabledBtnAjouter" mat-raised-button
                  class="colorGreen"><mat-icon>add</mat-icon>Ajouter</button>
                </div>
                <mat-form-field     appearance="outline"  style="width: 200px;">
                  <mat-label>Ecran</mat-label>
                  <mat-select name="param_ecran" #param_ecran="ngModel" [(ngModel)]="param_code"
                    placeholder="Ecran" (selectionChange)="onEcranChange()" required>
                    <mat-option *ngFor="let ec of listeEcran" [value]="ec.value">
                      {{ec.text}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- <span *ngIf="ordinaireEcran" > -->
                  <mat-form-field     appearance="outline"  style="width: 70px;">
                    <mat-label>Code</mat-label>
                    <input disabled="true" type="number" matInput name="DiverSys_Index" #DiverSys_Index="ngModel" [(ngModel)]="data.DiverSys_Index"
                      placeholder="Code" required>
                  </mat-form-field>
                  <mat-form-field     appearance="outline"   style="width: 200px;" *ngIf="showLibelle1">
                    <mat-label>Libellé</mat-label>
                    <input matInput name="DiverSys_Titre" #DiverSys_Titre="" [(ngModel)]="data.DiverSys_Titre"
                      placeholder="Libellé" required>
                  </mat-form-field>
                 
                  <mat-form-field     appearance="outline"  *ngIf="showGroupe">
                    <mat-label>Groupe</mat-label>
                    <mat-select name="groupe" [(ngModel)]="data.DiverSys_Group" (selectionChange)="onGroupeChange($event.value)" placeholder="Groupe"  required>
                      <mat-option *ngFor="let select of listeGroupe" [value]="getValueSelect(select,attributValueGroupeSelect)">
                        {{getValueSelect(select,attributTextGroupeSelect)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field     appearance="outline"  *ngIf="showGroupe1">
                    <mat-label>Condition</mat-label>
                    <mat-select name="groupe" [(ngModel)]="data.DiverSys_Group1" placeholder="Condition"  required>
                      <mat-option *ngFor="let select of listeGroupe1" [value]="getValueSelect(select,attributValueGroupe1Select)">
                        {{getValueSelect(select,attributTextGroupe1Select)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field     appearance="outline"  *ngIf="showGroupe2">
                    <mat-label>Condition</mat-label>
                    <mat-select name="groupe" [(ngModel)]="data.DiverSys_Group2" placeholder="Condition"  required>
                      <mat-option *ngFor="let select of listeGroupe2" [value]="getValueSelect(select,attributValueGroupe2Select)">
                        {{getValueSelect(select,attributTextGroupe2Select)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field     appearance="outline"  *ngIf="showGroupe3">
                    <mat-label>Condition</mat-label>
                    <mat-select name="groupe" [(ngModel)]="data.DiverSys_Group3" placeholder="Condition"  required>
                      <mat-option *ngFor="let select of listeGroupe3" [value]="getValueSelect(select,attributValueGroupe3Select)">
                        {{getValueSelect(select,attributTextGroupe3Select)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field     appearance="outline"  *ngIf="showGroupe4">
                    <mat-label>Condition</mat-label>
                    <mat-select name="groupe" [(ngModel)]="data.DiverSys_Group4" placeholder="Condition"  required>
                      <mat-option *ngFor="let select of listeGroupe4" [value]="getValueSelect(select,attributValueGroupe4Select)">
                        {{getValueSelect(select,attributTextGroupe4Select)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field     appearance="outline"  *ngIf="showLibelle">
                    <mat-label>Type</mat-label>
                    <mat-select name="type" [(ngModel)]="data.DiverSys_Libelle" placeholder="Type"  required>
                      <mat-option *ngFor="let select of listeLibelle" [value]="getValueSelect(select,attributValueLibelleSelect)">
                        {{getValueSelect(select,attributTextLibelleSelect)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
              </form>
            </mat-card-content>
          </mat-card>
        <!-- <div *ngIf="ordinaireEcran" > -->
          <mat-card class="example-card carClass">
              <mat-card-content>
                  <app-avt-listes #listeComponen 
                  [matSortDisabled]="true" 
                  [showFilter]="false" 
                  [heightTable]="'400'" 
                  [dataSourceBrut]="[]"
                  [displayedColumnsBrut]="Columns"
                  [listBtn]="listBtn" 
                  (btnTable)="clickBtnHeat($event)" 
                  (selectChange)="selectChange($event)">
                  </app-avt-listes>
              </mat-card-content>
          </mat-card>
        <!-- </div> -->
        <!-- <app-param-contrat *ngIf="showContrat"></app-param-contrat>
        <app-param-action *ngIf="showAction"></app-param-action>
        <app-param-compte *ngIf="showCompte"></app-param-compte>
        <app-param-heur *ngIf="showHeure"></app-param-heur> -->
        <br>       
      </mat-card-content>
    </mat-card>
  </div>